/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoDepositRequest model module.
 * @module model/WalletControllerDtoDepositRequest
 * @version 1.0
 */
class WalletControllerDtoDepositRequest {
    /**
     * Constructs a new <code>WalletControllerDtoDepositRequest</code>.
     * @alias module:model/WalletControllerDtoDepositRequest
     */
    constructor() { 
        
        WalletControllerDtoDepositRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoDepositRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoDepositRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoDepositRequest} The populated <code>WalletControllerDtoDepositRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoDepositRequest();

            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = ApiClient.convertToType(data['tokenType'], 'Number');
            }
            if (data.hasOwnProperty('amount')) {
                obj['amount'] = ApiClient.convertToType(data['amount'], 'Number');
            }
            if (data.hasOwnProperty('walletAddress')) {
                obj['walletAddress'] = ApiClient.convertToType(data['walletAddress'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoDepositRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoDepositRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['walletAddress'] && !(typeof data['walletAddress'] === 'string' || data['walletAddress'] instanceof String)) {
            throw new Error("Expected the field `walletAddress` to be a primitive type in the JSON string but got " + data['walletAddress']);
        }

        return true;
    }


}



/**
 * @member {Number} walletNo
 */
WalletControllerDtoDepositRequest.prototype['walletNo'] = undefined;

/**
 * @member {Number} tokenType
 */
WalletControllerDtoDepositRequest.prototype['tokenType'] = undefined;

/**
 * @member {Number} amount
 */
WalletControllerDtoDepositRequest.prototype['amount'] = undefined;

/**
 * @member {String} walletAddress
 */
WalletControllerDtoDepositRequest.prototype['walletAddress'] = undefined;






export default WalletControllerDtoDepositRequest;

